__turbopack_context__.v({
  "heading": "accordion-module-scss-module__G901nG__heading",
  "marker": "accordion-module-scss-module__G901nG__marker",
  "panel": "accordion-module-scss-module__G901nG__panel",
  "root": "accordion-module-scss-module__G901nG__root",
  "title": "accordion-module-scss-module__G901nG__title",
  "trigger": "accordion-module-scss-module__G901nG__trigger",
});
